import { Settings, Database, Binoculars, MapPin, Share2, Bot, LayoutGrid, MessageSquare } from 'lucide-react';
import { SIDEBAR_ITEMS } from '../utils/Constants';
import { TranslationKeys } from '../i18n/fr';

// Note (2026-05 chantier P.4) : l'item "Charte graphique" dédié dans le menu
// principal a été retiré. La charte est désormais accessible via un 3e toggle
// dans PositioningTab (icône Palette), cohérent avec son rôle "identité de la marque"
// qui s'inscrit dans le positionnement.

export const getMenuItems = (t: TranslationKeys) => [
  {
    icon: LayoutGrid,
    label: t.menu.spaces,
    id: SIDEBAR_ITEMS.SPACES
  },
  {
    icon: MapPin,
    label: t.menu.positioning,
    id: SIDEBAR_ITEMS.POSITIONING
  },
  {
    icon: Binoculars,
    label: t.menu.watch,
    id: SIDEBAR_ITEMS.WATCH
  },
  { 
    icon: Database, 
    label: t.menu.sources, 
    id: SIDEBAR_ITEMS.SOURCES 
  },
  {
    icon: Share2,
    label: t.menu.channels,
    id: SIDEBAR_ITEMS.CHANNELS
  },
  // V4-SIDEBAR-REMOVE-ANALYTICS-NEWSLETTER 2026-06-15 — Les items Analytics
  // (BarChart3) et Newsletter (Mail) ont été retirés de la sidebar (desktop +
  // mobile, source unique ici). Les composants AnalyticsTab/NewsletterTab restent
  // sur disque mais ne sont plus routés.
  // V4-ZERNIO-COMMENTS — inbox commentaires non répondus
  {
    icon: MessageSquare,
    label: t.menu.engagement,
    id: SIDEBAR_ITEMS.ENGAGEMENT
  },
  {
    icon: Bot,
    label: t.menu.automations,
    id: SIDEBAR_ITEMS.AUTOMATIONS
  }
];

export const getSettingsItem = (t: TranslationKeys) => ({
  icon: Settings,
  label: t.menu.settings,
  id: SIDEBAR_ITEMS.SETTINGS
});
